import { Box, Grid, TextField } from '@mui/material';
import React, { ChangeEvent } from 'react';
import { FilterElementProps } from '../index';
import { StaticAddon } from 'components/common/static-addon/StaticAddon';
import useBundleTranslation from 'i18n';

function TextFilter({ name, id, value, onChange, label, width, filterWidth }: FilterElementProps) {
    const { t } = useBundleTranslation(['components/common/grid/grid_filter']);

    const handleInputUpdate = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(name, event.target.value);
    };

    const containerWidth = filterWidth ? filterWidth + 'px' : undefined;
    const componentWidth = filterWidth ? '100%' : width ? width + 'px' : '144px';

    return (
        <Grid wrap="nowrap" item xs={'auto'} key={`grid-filter-${id}-${name}`}>
            <Box flexGrow="1" sx={{ display: 'flex', flexWrap: 'nowrap', width: containerWidth }}>
                {label && <StaticAddon>{t(label)}</StaticAddon>}
                <TextField
                    fullWidth
                    value={value}
                    onChange={handleInputUpdate}
                    data-test={id}
                    sx={{ width: componentWidth }}
                />
            </Box>
        </Grid>
    );
}

export default TextFilter;
